<span class="font-medium-title-large">Eingabe bestätigen</span>
<span class="font-regular-body-large">
  Bitte bestätige zuerst, dass du kein Roboter bist in dem du das folgende Wort
  eintippst: <span class="red">{{ selectedWord }}</span>
</span>
<form
  class="flex-c gap-16 align-self-stretch"
  [formGroup]="form"
  (submit)="closeDialog(true)">
  <div class="input-simple align-self-stretch">
    <input
      id="captcha"
      type="text"
      formControlName="userWord"
      class="input-field"
      placeholder="Captcha" />
  </div>
  @if (errorMessage) {
    <span class="font-regular-body-large red">
      {{ errorMessage }}
    </span>
  }
  <div class="flex-r gap-16 justify-center padding-top-16">
    <button
      type="button"
      class="inwi-text-button-large-secondary"
      (click)="closeDialog(false)">
      <div class="button-content">
        <div class="button-text">Abbrechen</div>
      </div>
    </button>
    <button type="submit" class="inwi-text-button-large-primary">
      <div class="button-content">
        <div class="button-text">Abschicken</div>
      </div>
    </button>
  </div>
</form>
